import { AbstractControl, ValidatorFn } from '@angular/forms';

const MIN_VALUE = 1;

export function priceMinValueValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    return control.value < MIN_VALUE ? { priceMin: true } : null;
  };
}
